/**
 * TanStack Query hooks for `score-based-routing-fraud-score-auto-allow-flag-bl`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	scoreBasedRoutingFraudScoreAutoAllowFlagBlQueryKeys,
	type CreateScoreBasedRoutingFraudScoreAutoAllowFlagBlBody,
	type ListScoreBasedRoutingFraudScoreAutoAllowFlagBlResponse,
	type ScoreBasedRoutingFraudScoreAutoAllowFlagBlRow,
} from "./api";

export function useScoreBasedRoutingFraudScoreAutoAllowFlagBlList(): UseQueryResult<ListScoreBasedRoutingFraudScoreAutoAllowFlagBlResponse, Error> {
	return useQuery({
		queryKey: scoreBasedRoutingFraudScoreAutoAllowFlagBlQueryKeys.list(),
		queryFn: list,
	});
}

export function useScoreBasedRoutingFraudScoreAutoAllowFlagBlCreate(): UseMutationResult<ScoreBasedRoutingFraudScoreAutoAllowFlagBlRow, Error, CreateScoreBasedRoutingFraudScoreAutoAllowFlagBlBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: scoreBasedRoutingFraudScoreAutoAllowFlagBlQueryKeys.all });
		},
	});
}

export function useScoreBasedRoutingFraudScoreAutoAllowFlagBlDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: scoreBasedRoutingFraudScoreAutoAllowFlagBlQueryKeys.all });
		},
	});
}
